import { AppBar, Box, Toolbar } from '@mui/material';
import PropTypes from 'prop-types';

function NavBar(props) {
  const { left, middle, right, position, sx, commonStyleExt } = props;
  const commonStyle = {
    display: 'flex',
    alignItems: 'center',
    flexBasis: 0,
    flexGrow: 1,
    gap: 1,
    ...commonStyleExt,
  };

  return (
    <AppBar position={position || 'static'} sx={sx}>
      <Toolbar disableGutters={false} variant="dense">
        {left && <Box sx={commonStyle}>{left?.map((component) => component)}</Box>}
        {middle && (
          <Box sx={{ ...commonStyle, justifyContent: 'center' }}>
            {middle?.map((component) => component)}
          </Box>
        )}
        {right && (
          <Box sx={{ ...commonStyle, justifyContent: 'end' }}>
            {right?.map((component) => component)}
          </Box>
        )}
      </Toolbar>
    </AppBar>
  );
}

NavBar.propTypes = {
  left: PropTypes.arrayOf(PropTypes.node),
  middle: PropTypes.arrayOf(PropTypes.node),
  right: PropTypes.arrayOf(PropTypes.node),
  position: PropTypes.string,
  sx: PropTypes.object,
  commonStyleExt: PropTypes.object,
};

export default NavBar;
